import { parseBackendDateTime } from '@/lib/format/datetime';
import type { ExecutionStep } from '@/types/imageWorkflow';

export function getExecutionStepKey(step: Pick<ExecutionStep, 'step_order' | 'node_key'>): string {
  return `${step.step_order}:${step.node_key}`;
}

function stepRecency(step: ExecutionStep): number {
  const timestamp = step.completed_at ?? step.started_at ?? step.created_at;
  return parseBackendDateTime(timestamp).getTime();
}

export function normalizeExecutionSteps(steps: readonly ExecutionStep[]): ExecutionStep[] {
  const latestByNode = new Map<string, ExecutionStep>();

  for (const step of steps) {
    const key = getExecutionStepKey(step);
    const current = latestByNode.get(key);
    if (!current || stepRecency(step) >= stepRecency(current)) {
      latestByNode.set(key, step);
    }
  }

  return Array.from(latestByNode.values()).sort((a, b) => {
    if (a.step_order !== b.step_order) return a.step_order - b.step_order;
    return a.node_key.localeCompare(b.node_key);
  });
}
